import React, {useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState} from "react";
import classnames from "classnames";
import useIsMounted from "../../../../../../hooks/use-is-mounted";
import ProductTagChip from "../../../../../../components/app-specific/product-tag-chip";
import {getProductTagsKey, normalizeProductTags} from "../../../../../../components/app-specific/product-tag-chip/normalize-product-tags";

const injectStaticSvgClasses = (container) => {
    if (!container)
        return;
    const SVGs = container.querySelectorAll('svg');
    for (const svg of SVGs) {
        svg.parentElement?.parentElement?.parentElement?.parentElement?.classList.remove('static-svg');
        if (svg.classList.contains('static-svg')) {
            svg.parentElement?.parentElement?.parentElement?.parentElement?.classList.add('static-svg');
        }
    }
    const PNGs = container.querySelectorAll('img');
    for (const png of PNGs) {
        png.parentElement?.parentElement?.classList.remove('static-svg');
        png.parentElement?.parentElement?.classList.add('static-svg');
    }
};

const UserPhoneHomepageTagsContainer = ({tags, onTagClicked: onTagClickedProps}) => {
    const [state, setState] = useState({tags: []});
    const isMounted = useIsMounted();
    /**@type {React.MutableRefObject<HTMLDivElement | null>}*/
    const containerRef = useRef(null);

    const tagsKey = useMemo(() => getProductTagsKey(tags), [tags]);
    const normalizedTags = useMemo(() => normalizeProductTags(tags), [tagsKey]);

    const iconSize = useMemo(() => 20, []);

    useLayoutEffect(() => {
        setState({tags: normalizedTags});
    }, [tagsKey, normalizedTags])

    useEffect(() => {
        if (!containerRef.current)
            return;
        injectStaticSvgClasses(containerRef.current);
        const timeoutId = window.setTimeout(() => injectStaticSvgClasses(containerRef.current), 150);
        return () => window.clearTimeout(timeoutId);
    }, [state.tags]);

    const onTagReady = useCallback(() => {
        if (!containerRef.current)
            return;
        injectStaticSvgClasses(containerRef.current);
    }, []);

    const onTagClicked = useCallback((e, tag) => {
        if (!isMounted() || !onTagClickedProps)
            return;
        e.preventDefault();
        e.stopPropagation();
        onTagClickedProps(tag);
    }, [isMounted, onTagClickedProps]);

    if (!normalizedTags.length) {
        return null;
    }

    return (
        <div className={classnames('user-phone-homepage-product-tags-container')}>
            <div ref={containerRef} className={'tags-container'}>
                {
                    state?.tags?.map(tag => (
                        <ProductTagChip
                            key={tag?.id}
                            tag={tag}
                            iconSize={iconSize}
                            chipClassName={'user-phone-homepage-tag'}
                            onTagReady={onTagReady}
                            onTagClicked={onTagClickedProps ? onTagClicked : undefined}
                        />
                    ))
                }
            </div>
        </div>
    );
}

export default UserPhoneHomepageTagsContainer;
